import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Link } from "@mui/material";

import { handlerSelectItemEvent } from "tracking/google/analytics";
import StraightUpPresenter from "presenters/StraightUpPresenter";
import { appRoutes } from "routes";
import { useTemplateGroupTracking, useCategory } from "hooks";
import LazyLoad from "components/LazyLoad";
import Placeholder from "components/Placeholder";
import { TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO, TEMPLATE_GROUP_TYPES } from "enums/templateGroup";

import { Card, CardOverlay, CardImg, NameOverlay, Name } from "./styles";

const STRAIGHT_UP_WIDTH = 400;

const StraightUp = ({ item, lazy, overflow, loading, isMasonryGrid, onClick, hasModulePosition = false }) => {
  const { trackClick } = useTemplateGroupTracking(item);
  const { category } = useCategory();
  const aspectRatio = TEMPLATE_GROUP_TYPE_THUMB_ASPECT_RATIO[TEMPLATE_GROUP_TYPES.straightUpEcard];
  const handleClick = () => {
    trackClick();

    if (onClick) onClick(item);

    if (!hasModulePosition) handlerSelectItemEvent(item, category);
  };

  if (loading)
    return (
      <Card data-testid="straightup-placeholder" aspectRatio={aspectRatio}>
        <Placeholder variant="rect" ratio="4/3" />
      </Card>
    );

  return (
    <Link onClick={handleClick} to={appRoutes.templateGroupPath(StraightUpPresenter.id(item))} component={NavLink}>
      <Card aspectRatio={aspectRatio}>
        {StraightUpPresenter.thumb(item) && (
          <LazyLoad lazy={lazy} overflow={overflow}>
            <CardImg
              src={StraightUpPresenter.thumb(item)}
              alt={StraightUpPresenter.name(item)}
              width={STRAIGHT_UP_WIDTH}
              widthMobile={226}
            />
          </LazyLoad>
        )}
        <CardOverlay />
        <NameOverlay isMasonryGrid={isMasonryGrid}>
          <Name variant="caption" align="center" isMasonryGrid={isMasonryGrid} title={StraightUpPresenter.name(item)}>
            {StraightUpPresenter.name(item)}
          </Name>
        </NameOverlay>
      </Card>
    </Link>
  );
};

StraightUp.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  lazy: PropTypes.bool,
  overflow: PropTypes.bool,
  loading: PropTypes.bool,
  isMasonryGrid: PropTypes.bool,
  onClick: PropTypes.func,
  hasModulePosition: PropTypes.bool,
};

export default StraightUp;
